import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=e1c041ac&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=e1c041ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c041ac",
  null
  
)

export default component.exports